import classNames from 'classnames';
import { addHours, format } from 'date-fns';
import { addLocale, locale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { mask, unMask } from 'remask';
import { Api } from '../../../../services/api';
import { userInfo } from '../../../../services/authHandlers';
import { CalendarPague, ConfirmDialogPague, InputNumberPague } from '../../../../styles/primeReactConfig';
import { confirmFooter } from '../../../confirmFooter';

export const PersonalInfo = ({ close, rowInfo, toast }) => {
  //console.log(rowInfo)
  const [devedorData, setDevedorData] = useState();
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [documento, setDocumento] = useState('');
  const [qtdParcelas, setQtdParcelas] = useState('');
  const [parcelasInfo, setParcelasInfo] = useState('');
  const [dadosPrivados, setDadosPrivados] = useState({})
  const [showPrivateInfo, setShowPrivateInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  addLocale('pt-BR', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Claro'
  });
  locale('pt-BR');

  const criaColunas = {
    telefone:
      [
        {
          field: "documento",
          //style: {minWidth:"20%" },
          header: "Documento",
        },
        {
          field: "numero",
          //style: {minWidth:"15%" },
          header: "Número",
          //body: (rowData) => formatCurrency(rowData.valor_pagamento_sem_desconto),
        },
        {
          field: "tipo",
          //style: {minWidth:"15%" },
          header: "Tipo",
          //body: (rowData) => formatCurrency(rowData.valor_para_pagamento),
        },
        {
          field: "data_registro",
          //style: {minWidth:"15%" },
          header: "Data Registro",
          //body: (rowData) => format(addHours(new Date(rowData.data_vencimento), 3), 'dd/MM/yyyy')
        },
      ],
    email: [
      {
        field: "documento",
        //style: {minWidth:"20%" },
        header: "Documento",
      },
      {
        field: "email",
        //style: {minWidth:"15%" },
        header: "Email",
      },
      {
        field: "data_registro",
        //style: {minWidth:"15%" },
        header: "Data Registro",
        //body: (rowData) => format(addHours(new Date(rowData.data_vencimento), 3), 'dd/MM/yyyy')
      },
    ],
    endereco: [
      {
        field: "documento",
        //style: {minWidth:"20%" },
        header: "Descrição",
      },
      {
        field: "cep",
        //style: {minWidth:"15%" },
        header: "CEP",
      },
      {
        field: "uf",
        //style: {minWidth:"15%" },
        header: "UF",
      },
      {
        field: "cidade",
        //style: {minWidth:"15%" },
        header: "Cidade",
      },
      {
        field: "bairro",
        //style: { minWidth: "20%" },
        header: "Bairro",
      },
      {
        field: "logradouro",
        //style: {minWidth:"15%" },
        header: "Logradouro",
      },
      {
        field: "numero",
        //style: {minWidth:"15%" },
        header: "Número",
      },
      {
        field: "complemento",
        //style: {minWidth:"15%" },
        header: "Complemento"
      },
      {
        field: "data_registro",
        //style: { minWidth: "20%" },
        header: "Data Registro",
      },
    ]
  }

  const getPrivadaInfo = async () => {
    try {
      const { data } = await Api.get(`users/user/privado/${rowInfo.usuario_documento}`)
      const dados_formatados = formataInfosTabelas(data)
      setDadosPrivados(dados_formatados)
      //console.log(data)
    } catch (error) {
      console.log(error.response)
      toast('error', 'Serviço indisponível, tente novamente mais tarde')
    }
  };

  const getDevedorInfo = async () => {
    try {
      const { data } = await Api.get(`users/user/beta/${rowInfo.usuario_documento}`);
      const parcelas = await Api.get(`/cobranca/pegatotalparcelas/${rowInfo.usuario_documento}`);
      setParcelasInfo(parcelas.data.cobranca_boleto_parcela)
      setQtdParcelas(parcelas.data.cobranca_boleto_parcela)
      setDevedorData(data.user);
      const userData = data.user;
      setNome(userData.usuario_nome);
      setDataNascimento(addHours(new Date(userData.usuario_data_nascimento), 3));
      setEmail(userData.usuario_email);
      setDocumento(mask(userData.usuario_documento, ['999.999.999-99', '99.999.999/9999-99']));
      setTelefone(mask(userData.usuario_telefone, ['(99) 9999-9999', '(99) 99999-9999']));
    } catch (error) {
      console.log(error.response)
      toast('error', 'Serviço indisponível, tente novamente mais tarde')
    }
  };
  const updateDevedorInfo = async () => {
    const updateData = {
      usuario_nome: nome,
      usuario_telefone: unMask(telefone, ['(99) 9999-9999', '(99) 99999-9999']),
      usuario_email: email,
      usuario_data_nascimento: format(dataNascimento, "yyyy-MM-dd"),
      usuario_documento: unMask(documento, ['999.999.999-99', '99.999.999/9999-99']),
      usuario_id: devedorData.usuario_id,
    }
    setLoading(true)
    try {
      toast('info', 'Atualizando informações!')
      await Api.put('/users/update-all', updateData);
      if (Number(parcelasInfo) !== Number(qtdParcelas))
        await Api.post('/cobranca/alteraparcelas', {
          documento: rowInfo.usuario_documento,
          qtdParcelas: qtdParcelas,
        })
      toast('success', 'Informações atualizadas com sucesso!')
    } catch (error) {
      console.log(error.response)
      toast('error', 'Erro ao atualizar as infromações do cliente')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getDevedorInfo()
    //getPrivadaInfo()
  }, [])

  function handleUpdate(event) {
    event.preventDefault()
    confirmDialog({
      message: "Deseja atualizar as informações do cliente selecionado?",
      header: "Atualizar cliente",
      icon: "pi pi-circle-info",
      acceptLabel: "Sim",
      accept: () => updateDevedorInfo(),
      rejectLabel: "Não",
      pt: ConfirmDialogPague,
      footer: (e) => confirmFooter(e)
    })
  }

  function formataInfosTabelas(array) {
    const {
      emails,
      contatos,
      enderecos
    } = array

    const emails_formatado = emails.map(email => {
      return (
        {
          documento: mask(email.assertiva_usuario_documento, ['999.999.999-99', '99.999.999/9999-99']),
          email: email.assertiva_email_endereco,
          data_registro: format(new Date(email.assertiva_usuario_data_assertivacao), 'dd/MM/yyyy')
        }
      )
    })

    const telefones_formatado = contatos.map(contato => {
      return (
        {
          documento: mask(contato.assertiva_usuario_documento, ['999.999.999-99', '99.999.999/9999-99']),
          numero: mask(contato.assertiva_telefone_numero, ['(99) 9999-9999', '(99) 99999-9999']),
          tipo: contato.assertiva_telefone_tipo,
          data_registro: format(new Date(contato.assertiva_usuario_data_assertivacao), 'dd/MM/yyyy')
        }
      )
    })

    const enderecos_formatado = enderecos.map(endereco => {
      return (
        {
          documento: mask(endereco.assertiva_usuario_documento, ['999.999.999-99', '99.999.999/9999-99']),
          cep: mask(endereco.assertiva_endereco_cep, '99999-999'),
          uf: endereco.assertiva_endereco_uf,
          cidade: endereco.assertiva_endereco_cidade,
          bairro: endereco.assertiva_endereco_bairro,
          logradouro: endereco.assertiva_endereco_logradouro,
          numero: endereco.assertiva_endereco_numero,
          complemento: endereco.assertiva_endereco_complemento,
          data_registro: format(new Date(endereco.assertiva_usuario_data_assertivacao), 'dd/MM/yyyy')
        }
      )
    })

    return ({ telefones_formatado, emails_formatado, enderecos_formatado })

  }

  return (
    <Dialog
      visible
      header="Informações do Cliente"
      onHide={() => close()}
      pt={{
        root: 'w-screen md:w-96 max-h-[80vh]',
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
    >
      <ConfirmDialog />
      {showPrivateInfo && false &&
        <Dialog
          visible
          header="Informações do Cliente"
          onHide={() => setShowPrivateInfo(false)}
          style={{
            heigth: '70vh',
            width: '70vw',
          }}
        >
          <DataTable
            value={dadosPrivados.telefones_formatado}
            header="Telefones"
          >
            {criaColunas.telefone.map((column, index) => (
              <Column
                key={index}
                header={column.header}
                field={column.field}
                // headerStyle={column.header}
                body={column.body}
                style={column.style}
              />
            ))}
          </DataTable>
          <DataTable
            value={dadosPrivados.emails_formatado}
            header="Emails"
          >
            {criaColunas.email.map((column, index) => (
              <Column
                key={index}
                header={column.header}
                field={column.field}
                // headerStyle={column.header}
                body={column.body}
                style={column.style}
              />
            ))}
          </DataTable>
          <DataTable
            value={dadosPrivados.enderecos_formatado}
            header="Endereços"
          >
            {criaColunas.endereco.map((column, index) => (
              <Column
                key={index}
                header={column.header}
                field={column.field}
                // headerStyle={column.header}
                body={column.body}
                style={column.style}
              />
            ))}
          </DataTable>
        </Dialog>
      }
      {devedorData ?
        (<div className="grid font-semibold mt-1 p-1">
          <form onSubmit={(e) => handleUpdate(e)}>
            <div className="grid text-lg w-full" >

              <div className="w-full text-left grid mt-2">
                <label htmlFor="documento">CPF/CNPJ</label>
                <InputText
                  value={documento}
                  onChange={({ target }) => {
                    setDocumento(
                      mask(unMask(target.value), [
                        '999.999.999-99',
                        '99.999.999/9999-99'
                      ])
                    )
                  }}
                  id="documento"
                  required
                />
              </div>

              <div className="w-full text-left grid mt-2">
                <label htmlFor="name">Nome</label>
                <InputText
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  id="name"
                  required
                  type="text"
                />
              </div>

              <div className="w-full text-left grid mt-2">
                <label htmlFor="nascimento">Data de Nascimento/Criação</label>
                <Calendar
                  value={dataNascimento}
                  maxDate={today}
                  pt={CalendarPague}
                  locale="pt-BR"
                  dateFormat="dd/mm/yy"
                  onChange={(e) => setDataNascimento(e.value)}

                  yearRange="1900:2030"
                  showOnFocus={false}
                  showIcon
                  icon={<FaCalendarAlt className={
                    classNames('px-4 rounded-r-lg',
                      'w-[50px] h-full',
                      'bg-sky-400 text-white hover:bg-sky-500',
                      'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                    )}
                  />}
                  id="nascimento"
                  required
                  mask="99/99/9999"
                />
              </div>

              <div className="w-full text-left grid mt-2">
                <label htmlFor="email">E-mail</label>
                <InputText
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="email"
                  //required 
                  type="email"
                />
              </div>

              <div className="w-full text-left grid mt-2">
                <label htmlFor="contato">Contato</label>
                <InputText
                  value={telefone}
                  onChange={({ target }) =>
                    setTelefone(
                      mask(unMask(target.value), [
                        '(99) 9999-9999',
                        '(99) 99999-9999'
                      ])
                    )
                  }
                  id="contato"
                  //required 
                  type="text"
                />
              </div>

              <div className="w-full text-left grid mt-2">
                <label htmlFor="qtd_parcelas">Máx Parcelas Boleto</label>
                <InputNumber
                  pt={InputNumberPague}
                  value={qtdParcelas}
                  onChange={e => setQtdParcelas(e.value)}
                  id="qtd_parcelas"
                  required
                />
              </div>

            </div>
            {userInfo.usuario_id === '6917f15d-1563-42f7-b68a-b618ec8c5b25' && false &&
              (rowInfo.cobranca_tipo_pagamento === 'Em Processamento' || rowInfo.cobranca_tipo_pagamento === 'Pago') &&
              <div className="w-full p-fluid mt-5 px-3 text-center">
                <Button
                  label="Ver mais informações"
                  type="button"
                  icon="pi pi-plus"
                  onClick={() => { setShowPrivateInfo(true) }}
                  severity="info"
                />
              </div>
            }
            <div className="w-full p-fluid mt-5 px-3 text-center">
              <Button
                loading={loading}
                label="Atualizar"
                type="submit"
                severity='success'
              />
            </div>
          </form>
        </div>) : (<div className="w-full p-fluid mt-5 text-center">
          <ProgressSpinner strokeWidth="6" />
        </div>)
      }
    </Dialog>
  )
}
